<template>
	<div class="h-100 no-gutters row">
		<div class="d-lg-flex d-xs-none col-md-7 col-lg-8">
			<div class="slider-light w-100">
				<div class="slick-slider slick-initialized h-100">
					<div class="h-100">
						<div
							class="position-relative h-100 d-flex justify-content-center align-items-center bg-premium-dark"
							tabindex="-1"
						>
							<div
								class="slide-img-bg"
								style='background-image: url("//static.vgroup.cl/lms5/archivo/2020/06/StockSnap_F5TANEQVUH.jpg")'
							></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="h-100 d-md-flex d-sm-block bg-white justify-content-center align-items-center col-md-5 col-lg-4"
			style="min-height: 100vh"
		>
			<div class="mx-auto app-login-box col-md-10">
				<form
					@submit.prevent="envioForm()"
					autocomplete="off"
					class="form-horizontal"
				>
					<img
						id="LogoVgroup"
						alt="VGroup"
						src="https://static.vgroup.cl/2024/Suite%20herramientas%20TI/Logo_VG_original.png"
						style="margin-left: 6px;margin-top: 6px;width: 100%;"
					/>
					<h2
						align="center"
						style="font-family: sans-serif;margin-top:10%"
					>
						Administrador Cliente
					</h2>
					<div class="form-group ">
						<p style="margin-top:10%">
							Ingresa tu rut o email asociado a un administrador
						</p>
						<p v-if="msgError" style="color:red">
							Los datos no coinciden en el sistema
							<i class="far fa-frown"></i>
						</p>
					</div>
					<div class="form-group ">
						<label for="">Rut o Email</label>
						<input
							v-on:keyup="validationField()"
							type="text"
							class="form-control inputRut"
							v-model="rut"
							placeholder="Ej: email@example.com o 12345678-9"
						/>
						<p v-if="rutInValido && tipoLogin == 'email'" style="color:red">Email Inválido</p>
						<p v-if="rutInValido && tipoLogin == 'rut'" style="color:red">Rut Inválido</p>
					</div>
					<div class="form-group">
						<label for="">Contraseña</label>
						<input
							type="password"
							placeholder="Ej: 123456"
							class="form-control"
							v-model="password"
						/>
					</div>
					<div
						class="form-group d-flex flex-row justify-content-center"
					>
						<button
							v-if="rutInValido"
							class="btn btn-primary"
							style="width:100%"
							disabled
						>
							Iniciar Sesión
						</button>
						<button
							v-else
							class="btn btn-primary"
							type="submit"
							style="width:100%"
						>
							Iniciar Sesión
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import router from "../router";
export default {
	data() {
		return {
			mensaje: "",
			rut: "",
			rutFormateado: "",
			rutInValido: false,
			rutSimple: "",
			password: "",
			rutLimpio: "",
			msgError: false,
			showBottom: false,
			tipoLogin:"rut"
		};
	},

	methods: {
		...mapActions(["setAccessToken"]),
		...mapActions("alumno", ["updateJsonCoordinadora"]),

		makeToast(variant = null, error) {
			this.$bvToast.toast(error, {
				title: "Error Encontrado",
				variant: variant,
				solid: true,
			});
		},
		async envioForm() {
			this.msgError = false;
			let data = [];
			if(this.tipoLogin == "email"){
				data = await this.axios.post("api/login-cliente", {
					email: this.rut,
					password: this.password,
					tipoLogin:this.tipoLogin
				});
			}else{
				data = await this.axios.post("api/login-cliente", {
					numeroDocumento: this.rutLimpio,
					password: this.password,
					tipoLogin:this.tipoLogin
			    });
			}

			const {error} = data.data
			const { msg } = data.data;

			this.msgError = (error === "Unauthorized") ? true : false;
			
			const alertToast =
				(msg === "accesoDenegado")
					? this.makeToast("danger", error)
					: false;
			
			if ( !error && !msg) {
			
				var token = "Bearer " + data.data.token.original.access_token;
				var user = data.data.token.original.user;
				this.setAccessToken(token);
				router.push({ name: "index" });
			}

		},
		validationRut() {
			let rutSimple = this.rut.replace(/\./g, "");
			var guion = rutSimple.replace(/\-/g, "");

			rut = rutSimple.split("-");
			this.rutLimpio = rut[0];

			// Divide el valor ingresado en dígito verificador y resto del RUT.
			let cuerpo = guion.slice(0, -1);
			let dv = guion.slice(-1).toUpperCase();

			// Formatear RUN
			var rut = cuerpo + "-" + dv;

			// Calcular Dígito Verificador
			var suma = 0;
			var multiplo = 2;

			if (cuerpo.length < 7) {
				this.rutInValido = true;
				//console.log("RUT Incompleto");
				return false;
			}

			// Para cada dígito del Cuerpo
			for (var i = 1; i <= cuerpo.length; i++) {
				// Obtener su Producto con el Múltiplo Correspondiente
				var index = multiplo * rutSimple.charAt(cuerpo.length - i);

				// Sumar al Contador General
				suma = suma + index;

				// Consolidar Múltiplo dentro del rango [2,7]
				if (multiplo < 7) {
					multiplo = multiplo + 1;
				} else {
					multiplo = 2;
				}
			}

			// Calcular Dígito Verificador en base al Módulo 11
			var dvEsperado = 11 - (suma % 11);
			// Casos Especiales (0 y K)
			dv = dv == "K" ? 10 : dv;
			dv = dv == 0 ? 11 : dv;

			if (dvEsperado != dv) {
				//console.log("RUT Inválido");
				this.rutInValido = true;
				return false;
			} else {
				this.rutInValido = false;
				//console.log("valido");
			}
		},
		validationField(){
			if(this.rut == ""){
				this.rutInValido = false;
				return;
			}
			if(!this.rut.includes("@")){
				this.tipoLogin = "rut";
			}else{
				this.tipoLogin = "email";
			}
			if(this.tipoLogin == "email"){
				 const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				 if(re.test(String(this.rut).toLowerCase())){
					 this.rutInValido = false;
				 }else{
					 this.rutInValido = true;
				 }
			}else{
				//llamar al metodo que valida el rut
				this.validationRut();
			}
		}
	},
};
</script>
<style scoped>
.slick-slider .slide-img-bg {
	opacity: 0.8 !important;
}

.slick-slider .slide-img-bg {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-size: cover;
	opacity: 0.4;
	z-index: 10;
}
</style>
